<template lang="pug">

.page.page_offset_top.page_offset_bottom
  .page-meta
    .container
      .page-meta__inner
        breadcrumbs
  tabs(type="airport-tabs")
    tab(v-for="tab, index in tabs" :key="index" :name="tab.name" :subtitle="tab.subtitle" :selected='index === 0')
      .airport-content
        .airport-content__inner
          .airport-content__col(v-for="item, index in airportContent")
            .airport-content__desc
              h2.airport-content__title.title.title_size_m {{ index }}. {{ item.name }}
              .airport-content__desc
                p Для присоединения к сервису нужно иметь при себе паспорт, водительское удостоверение и банковскую карту. Для присоединения к сервису нужно иметь при себе паспорт, водительское удостоверение и банковскую карту.

        .preview-img-list
          .airport-content__img-wrap.preview-img-item(v-for="item, index in items")
            img(:src="item.src" @click="$photoswipe.open(index, items)").airport-content__img

</template>

<script>
import Tabs from './../components/tabs'
import Tab from './../components/tab'

export default {
  props: [],
  components: {
    Tabs,
    Tab
  },
  data () {
    return {
      airportContent: [
        {
          name: 'Где припарковаться'
        },
        {
          name: 'Как въехать в паркинг'
        },
        {
          name: 'Как выехать из паркинга'
        }
      ],
      tabs: [
        {
          name: 'Шереметьево',
          subtitle: 'Москва'
        },
        {
          name: 'Домодедово',
          subtitle: 'Москва'
        },
        {
          name: 'Аэропорт Сочи',
          subtitle: 'Сочи'
        }
      ],
      items: [
        {
          src: '/static/img/blanket.jpg',
          w: 915,
          h: 608
        }
      ]
    }
  },
  methods: {

  },
  computed: {

  }

}
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/views/Airports.vue